export default {

  // createOrder(plan_id, coupon = null) {
  //   return env.API.post('/plan/paypal/order', {
  //     planId: plan_id,
  //     coupon: coupon,
  //   });
  // },

  // approveOrder(order_id) {
  //   return env.API.post('/plan/paypal/approve', {
  //     orderId: order_id,
  //   });
  // },

  // createStripeSession(plan_id, coupon = null) {
  //   return env.API.post('/plan/stripe/session', {
  //     planId: plan_id,
  //     coupon: coupon,
  //   });
  // },

  getPlansStats() {
    return env.API.get('/plan/stats');
  },

  setSubscription(plan, period, coupon) {
    // marketing/subscribe
    return env.API.post('/plan/subs', {
      plan: plan,
      period: (period == 'monthly') ? 'month' : 'year',
      coupon: coupon,
    });
  },

  cancelSubscription() {
    return env.API.delete('/plan/subs')
  },
  // setFeedback(feedback) {
  //   return env.API.post('/plan/setFeedback', {feedback})
  // },

  setFeedback(data) {
    return env.API.post('/user/feedback/send', data)
  },
  getFeedbacks() {
    return env.API.get('/user/feedback/options')
  },

  buyImpact(coupon, pm) {
    // marketing/subscribe
    return env.API.post('/plan/buy/impact', {
      coupon: coupon,
      pm: pm,
    });
  },

  checkSubscriptionStatus() {
    return env.API.get('/plan/subs/status');
  },

  getNextBillingDate() {
    return env.API.get('/plan/subs/next-billing');
  },

  setPause(from, till) {
    return env.API.post('/plan/subs/pause', {
      from, till
    });
  },

  removePause() {
    return env.API.delete('/plan/subs/pause');
  },
}
